(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"), require("styled-components"), require("@feature-hub/react"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "react-dom", "styled-components", "@feature-hub/react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("react-dom"), require("styled-components"), require("@feature-hub/react")) : factory(root["react"], root["react-dom"], root["styled-components"], root["@feature-hub/react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), (__WEBPACK_EXTERNAL_MODULE__9155__, __WEBPACK_EXTERNAL_MODULE__9514__, __WEBPACK_EXTERNAL_MODULE__8694__, __WEBPACK_EXTERNAL_MODULE__9544__) => {
return 